import moment from 'moment';
import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { Col, Container, Row, Table } from "react-bootstrap";
import swal from 'sweetalert';
import { ThreeDotSpinner } from '../../common/loader/loader';
import enquiryService from '../../service/EnquiryService';
import ConfirmDialog from '../../common/ConfirmDialog';

export const EnquiryManagement = () => {

  const [Loader, setLoader] = useState(false)
  const [enquiries, setEnquiries] = useState([])
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 10, pageRange: 0, totalCount: 0 })

  useEffect(() => {
    fetchEnquiries()
  }, [pagination.pageNumber])

  const fetchEnquiries = async () => {
    setLoader(true);
    const params = {page: pagination.pageNumber - 1, size: pagination.pageSize}
    const response = await enquiryService.getAll(params);
    if (response.status == 200) {
      setLoader(false);
      setEnquiries(response.data.data.enquiries)
      setPagination({
        ...pagination,
        totalCount: response.data.data.count
      })
    }
  }

  const handlePageChange = (pageNumber) => {
    setPagination({
      ...pagination,
      pageNumber: pageNumber
    })
  };

  const handleStatusChange = async (enquiryId , status) => {
    const data = {
      enquiryId : enquiryId,
      status : status
    }
    const response = await enquiryService.updateStatus(data);
    if (response.status == 200) {
      swal({ icon: 'success', text: response.data.message, button: "OK" });
      fetchEnquiries();
    }
  }

  return (
    <>
      {Loader && <ThreeDotSpinner />}
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">

            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex ">
                    <h2 className="align-self-center m-0">Enquiry Management</h2>
                  </div>

                </div>
              </Col>
            </Row>

            <Row className="pb-4 justify-content-center">
              <Col md={12}>
                <div className="audit-request-box">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Creation Date</th>           
                        <th>Enquiry By</th>               
                        <th>Enquiry</th>
                        <th>Location</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody> 
                      { enquiries.length > 0 &&
                        enquiries.map((enquiry, index) => (
                          <tr key={index}>
                            <td>{moment(enquiry?.createdAt).format('DD-MM-YYYY')}</td>
                            <td>
                              <a
                                href={`/users/${enquiry?.userId?._id}`}
                                target="_blank"
                              >
                                <div className='view-user'>
                                 {enquiry?.userId?.fullName}
                                </div>
                              </a>
                            </td>
                            <td className="wrap-text">{enquiry?.enquiry}</td>                   
                            <td className="wrap-text">{enquiry?.address}</td> 
                            <td>
                              {enquiry?.status === "PENDING" ? (
                                <div style={{ display: "flex", gap: "0.5rem" }}>
                                  <ConfirmDialog
                                    title="Are you sure?"
                                    text="you want to accept this enquiry."
                                    confirmText="Accept"
                                    cancelText="No, cancel!"
                                    onConfirm={() => handleStatusChange(enquiry._id, "ACCEPT")}
                                      confirmButtonClass="accept"
                                  />
                                  <ConfirmDialog
                                    title="Are you sure?"
                                    text="you want to reject this enquiry."
                                    confirmText="Reject"
                                    cancelText="No, cancel!"
                                    onConfirm={() => handleStatusChange(enquiry._id, "REJECT")}
                                    confirmButtonClass="reject" 
                                  />
                                </div>
                              ) : (
                                <span className="capitalize">{enquiry?.status === "ACCEPT" ? "Accepted" : "Rejected"}</span>
                              )}
                            </td>                            
                          </tr>
                        ))
                      }

                      {
                        pagination.totalCount == 0 &&

                        <tr className="no-dat-found-box">
                          <td colSpan={10}>
                            <img src={require("../../assets/images/no-data-bg.gif")} alt="no-data-image" />
                            <h3 className="text-center">
                              No data found
                            </h3>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                  {pagination.totalCount > pagination.pageSize &&
                    <Pagination
                      activePage={pagination.pageNumber}
                      itemsCountPerPage={pagination.pageSize}
                      totalItemsCount={pagination.totalCount}
                      pageRangeDisplayed={pagination.pageRange}
                      onChange={(e) => handlePageChange(e)}
                      prevPageText={"Prev"}
                      nextPageText={"Next"}
                    />
                  } 
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
